module.exports = __webpack_public_path__ + "img/logo-white.83d42c55.png";